import * as React from 'react';

function SvgPayoutIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.588 5.5l.495-.54v3.29a.916.916 0 101.833 0V4.96l.495.503a.916.916 0 001.339.037.916.916 0 000-1.302L11.65 2.1a.917.917 0 00-.302-.192.917.917 0 00-.697 0 .917.917 0 00-.302.192l-2.1 2.063A.946.946 0 109.59 5.5zM11 11a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zm0 3.667a.917.917 0 110-1.833.917.917 0 010 1.833zm-6.417-.917a.917.917 0 101.834 0 .917.917 0 00-1.834 0zm12.834 0a.917.917 0 10-1.835 0 .917.917 0 001.834 0zm.916-6.417h-3.666a.917.917 0 000 1.834h3.666a.917.917 0 01.917.916v7.334a.916.916 0 01-.917.916H3.667a.917.917 0 01-.917-.916v-7.334a.917.917 0 01.917-.916h3.666a.917.917 0 100-1.834H3.666a2.75 2.75 0 00-2.75 2.75v7.334a2.75 2.75 0 002.75 2.75h14.667a2.75 2.75 0 002.75-2.75v-7.334a2.75 2.75 0 00-2.75-2.75z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgPayoutIcon;
